import { validateOptionalPremiseId } from '@dte/otw-azure-functions/src/common/util/validation/validatePremiseId';

export function getPremiseStatusURL(premiseId: string | undefined): string | undefined {
	const premiseIdValue = validateOptionalPremiseId(premiseId);
	if (!premiseIdValue) {
		return undefined;
	}

	return `/authenticated/data/premises/${premiseIdValue}`;
}
